<template>
  <div>
    <div class="time-table">
      <div class="time-header">
        <div class="time-header-left">星期/时间</div>
        <div class="time-header-right">
          <div class="time-header-right-time">
            <div class="time-header-right-time1 time-border">00:00 - 12:00</div>
            <div class="time-header-right-time1">12:00 - 24:00</div>
          </div>
          <div class="time-header-right-detail">
            <div v-for="item in timenumber" :key="item" class="time-header-right-detail1 time-border">
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <div class="time-content" v-for="(w, wIndex) in week" :key="w">
        <div class="time-content-left">{{ w }}</div>
        <div class="time-content-right" @mousedown="mousedownStart" @mousemove="mousemoving">
          <div
            v-for="num in timenumber1"
            :key="num"
            class="time-content-right-detail time-border"
            :class="{
              currentNode: currentNodes.includes(`${wIndex + 1}${num}`),
              checkedNode: checkedNodes.includes(`${wIndex + 1}${num}`),
            }"
            :data-position="wIndex + 1 + ',' + num"
          ></div>
        </div>
      </div>
    </div>
    <div class="select-btn">
      <div>已选时间段</div>
      <div><span class="select-all" @click="resetSelect">反向选择</span><span class="select-all" @click="clearSelect">清空选择</span></div>
    </div>
    <div>
      <div class="select-time">
        <div>星期一</div>
        <div v-for="item in day1" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期二</div>
        <div v-for="item in day2" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期三</div>
        <div v-for="item in day3" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期四</div>
        <div v-for="item in day4" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期五</div>
        <div v-for="item in day5" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期六</div>
        <div v-for="item in day6" :key="item">{{ item }}</div>
      </div>
      <div class="select-time">
        <div>星期日</div>
        <div v-for="item in day7" :key="item">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import _ from "lodash";
export default {
  data() {
    return {
      timenumber: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
      timenumber1: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
        36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
      ],
      week: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
      start_x: null,
      start_y: null,
      end_x: null,
      end_y: null,
      clientHeight: null,
      clientWidth: null,
      start: false, // 鼠标点击才开始计算
      currentNodes: [], // 当前框选的节点
      checkedNodes: [], // 所有选择的节点
      start_position: null,
      checkedValue: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      day1: [],
      day2: [],
      day3: [],
      day4: [],
      day5: [],
      day6: [],
      day7: [],
    };
  },
  mounted() {
    window.addEventListener("mouseup", this.mouseupend);
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.mouseupend);
  },
  methods: {
    mousedownStart(e) {
      this.start_x = e.clientX;
      this.start_y = e.clientY;
      this.clientHeight = e.target.clientHeight;
      this.clientWidth = e.target.clientWidth;
      this.start = true;
      // 每次开始点击前 清空上一次框选得最后位置；
      this.end_x = null;
      this.end_y = null;
      this.start_position = e.target.dataset.position;
    },
    mousemoving(e) {
      if (!this.start) {
        return;
      }
      this.handleChecked(e);
    },
    handleChecked(e, flag) {
      //动态计算鼠标框选的位置大小
      let refsNodes = [];
      const start_array = this.start_position?.split(",");
      const end_array = e.target.dataset.position.split(",");
      if (start_array) {
        const minX = Math.min(Number(start_array[0]), Number(end_array[0]));
        const maxX = Math.max(Number(start_array[0]), Number(end_array[0]));
        const minY = Math.min(Number(start_array[1]), Number(end_array[1]));
        const maxY = Math.max(Number(start_array[1]), Number(end_array[1]));
        for (let i = minX; i <= maxX; i++) {
          for (let j = minY; j <= maxY; j++) {
            refsNodes.push(`${i}${j}`);
          }
        }
      }
      // 页面效果显示用的
      if (flag) {
        if (this.checkedNodes.length == 0) {
          this.checkedNodes = refsNodes;
        } else {
          refsNodes.map((item) => {
            if (this.checkedNodes.indexOf(item) > -1) {
              this.checkedNodes.splice(this.checkedNodes.indexOf(item), 1);
            } else {
              this.checkedNodes.push(item);
            }
          });
        }

        // 给后端传值用的
        refsNodes.map((node) => {
          this.checkedValue[Number(node.substr(0, 1) - 1) * 48 + Number(node.substr(1)) - 1]
            ? Vue.set(this.checkedValue, [Number(node.substr(0, 1) - 1) * 48 + Number(node.substr(1)) - 1], 0)
            : Vue.set(this.checkedValue, [Number(node.substr(0, 1) - 1) * 48 + Number(node.substr(1)) - 1], 1);
        });

        // 显示每天选中的时间段
        this.checkedShowtime();
      } else {
        this.currentNodes = refsNodes;
      }
    },
    checkedShowtime() {
      let temp1 = [],
        temp2 = [],
        temp3 = [],
        temp4 = [],
        temp5 = [],
        temp6 = [],
        temp7 = [];
      calcTime(this.checkedValue.slice(0, 48)).map((item) => {
        temp1.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(48, 96)).map((item) => {
        temp2.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(96, 144)).map((item) => {
        temp3.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(144, 192)).map((item) => {
        temp4.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(192, 240)).map((item) => {
        temp5.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(240, 288)).map((item) => {
        temp6.push(formatStemp(item));
      });
      calcTime(this.checkedValue.slice(288, 336)).map((item) => {
        temp7.push(formatStemp(item));
      });
      this.day1 = temp1;
      this.day2 = temp2;
      this.day3 = temp3;
      this.day4 = temp4;
      this.day5 = temp5;
      this.day6 = temp6;
      this.day7 = temp7;
    },
    mouseupend(e) {
      if (e.target.dataset.position) {
        this.end_x = e.clientX;
        this.end_y = e.clientY;
        this.handleChecked(e, true);
      } else {
        this.start_x = null;
        this.start_y = null;
        this.end_x = null;
        this.end_y = null;
      }
      this.start = false;
      this.currentNodes = [];
    },
    clearSelect() {
      this.start_x = null;
      this.start_y = null;
      this.end_x = null;
      this.end_y = null;
      this.start_position = null;
      this.start = false; // 鼠标点击才开始计算
      this.currentNodes = []; // 当前框选的节点
      this.checkedNodes = []; // 所有选择的节点

      this.checkedValue = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ];
      this.day1 = [];
      this.day2 = [];
      this.day3 = [];
      this.day4 = [];
      this.day5 = [];
      this.day6 = [];
      this.day7 = [];
    },
    resetSelect() {
      let refsNodes = [],
        otherSelectNodes = [];
      for (let i = 1; i <= 7; i++) {
        for (let j = 1; j <= 48; j++) {
          refsNodes.push(`${i}${j}`);
        }
      }
      refsNodes.map((item) => {
        if (!this.checkedNodes.includes(item)) {
          otherSelectNodes.push(item);
        }
      });
      // 节点反选
      this.checkedNodes = otherSelectNodes;
      //值反选
      this.checkedValue.map((item, index) => {
        this.checkedValue[index] = item ? 0 : 1;
      });
      // 时间显示反选
      this.checkedShowtime();
      this.start_x = null;
      this.start_y = null;
      this.end_x = null;
      this.end_y = null;
      this.start_position = null;
      this.start = false; // 鼠标点击才开始计算
    },
    showSelectNode(nodes) {
      this.checkedValue = nodes;
      let temparr = [];
      nodes.map((item, index) => {
        if (Number(item)) {
          temparr.push(`${Math.floor(index / 48) + 1}${(index % 48) + 1}`);
        }
      });
      this.checkedNodes = temparr;
      this.checkedShowtime();
    },
  },
};

function calcTime(arr) {
  let newArr = [],
    temArr = [];
  for (let m = 0; m <= 48; m++) {
    if (arr[m]) {
      temArr.push((m + 1) * 30);
    } else {
      temArr.length && newArr.push(temArr);
      temArr = [];
      continue;
    }
  }
  return newArr;
}

function formatTime(time) {
  return `${String(time / 60).split(".")[0] < 10 ? `0${String(time / 60).split(".")[0]}` : String(time / 60).split(".")[0]}:${
    String(time / 60).split(".")[1] ? "30" : "00"
  }`;
}

function formatStemp(arr) {
  if (arr.length == 1) {
    return `${formatTime(arr[0] - 30)}~${formatTime(arr[0])}`;
  } else {
    return `${formatTime(arr[0] - 30)}~${formatTime(arr[arr.length - 1])}`;
  }
}
</script>

<style lang="less" scoped>
.time-header {
  display: flex;
  text-align: center;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
  .time-header-left {
    width: 100px;
    cursor: pointer;
    font-weight: 700;
  }
  .time-header-right {
    font-weight: 700;
    width: 100%;
    cursor: pointer;
    .time-header-right-time {
      border-bottom: 1px solid #d8d8d8;
      display: flex;
      .time-header-right-time1 {
        flex: 1;
        height: 32px;
        line-height: 32px;
      }
    }
    .time-header-right-detail {
      display: flex;
      .time-header-right-detail1 {
        flex: 1;
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
.time-table {
  border: 1px solid #d8d8d8;
  text-align: center;
  font-size: 12px;
  user-select: none;
  margin: 14px;
  width: 700px;
}
.time-border {
  border-left: 1px solid #d8d8d8;
}
.time-unline {
  border-bottom: none !important;
}
.time-content {
  display: flex;
  text-align: center;
  border-bottom: 1px solid #d8d8d8;
  height: 32px;
  .time-content-left {
    width: 100px;
    cursor: pointer;
    line-height: 32px;
    font-weight: 700;
  }
  .time-content-right {
    width: 100%;
    display: flex;
    .time-content-right-detail {
      flex: 1;
      cursor: cell;
      background-color: #f0f0f0;
    }
  }
}
.time-content:last-child {
  border-bottom: none;
}

.checkedNode {
  background: #0b75ff !important;
}
.currentNode {
  background: #a6b7db !important;
}
.select-time {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 12px;
  width: 700px;
  div {
    margin: 0 12px;
  }
}
.select-btn {
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  width: 700px;
  margin: 2px 12px;
  .select-all {
    color: #3c91ff;
    margin: 0 12px;
    cursor: pointer;
  }
}
</style>
